export const formatDateToString = (date: Date): string => {
  const month = "" + (date.getMonth() + 1);
  const day = "" + date.getDate();
  const year = date.getFullYear();

  return [day, month, year].join("-");
};

export const getDateRangeByDays = (days = 7) => {
  const endDate = new Date();
  const startDate = new Date(endDate);
  startDate.setDate(endDate.getDate() - days);
  return { startDate: startDate, endDate: endDate };
};

export const springPromoCode = [
  "SW139L",
  "TP140L",
  "SW139M",
  "TP140M",
  "SW139K",
  "TP140K",
  "J138L",
  "J138M",
  "SW225M",
  "P200LS",
  "P200MS",
  "SW025L",
  "SW026L",
  "SW025M",
  "SW026M",
];
